module.exports = function isFunction(x) {
  return typeof x === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isFunction.js
// module id = 12
// module chunks = 0